// Pages « transitaire + ville » (en français : la recherche en arabe est presque nulle, Semrush base Maroc, 28/10/2026).
// Chaque ville a son propre texte (portes d'entrée, secteurs, questions locales) : pas de pages copiées d'une ville à l'autre.
// Rien d'inventé : pas de délai, de prix ni de chiffre ; seulement ce qui est connu de la ville et ce que fait COGETRANS.
export type Bloc = { titre: string; texte: string[]; liste?: string[] }
export type Question = { q: string; r: string }

export type Ville = {
  slug: string
  nom: string
  titre: string // balise <title>, commence par le mot-clé
  description: string
  h1: string
  chapo: string
  portes: string[] // ports, aéroports, postes frontières
  blocs: Bloc[]
  faq: Question[]
}

export const villes: Ville[] = [
  {
    slug: 'transitaire-casablanca',
    nom: 'Casablanca',
    titre: 'Transitaire à Casablanca : dédouanement import-export',
    description: 'Transitaire à Casablanca depuis 2003 : dédouanement au port et à l’aéroport Mohammed V, import, export, fret maritime et aérien. Devis sur demande.',
    h1: 'Votre transitaire à Casablanca',
    chapo: 'COGETRANS est installée à Casablanca depuis 2003. Nous préparons et suivons vos dossiers de dédouanement au port de Casablanca, à l’aéroport Mohammed V et dans les zones d’activité de la région.',
    portes: ['Port de Casablanca', 'Aéroport Mohammed V (Nouaceur)', 'Zones industrielles et logistiques de la région'],
    blocs: [
      {
        titre: 'Dédouanement au port de Casablanca',
        texte: [
          'Le port de Casablanca reçoit une grande partie des conteneurs destinés au marché marocain. Quand votre marchandise arrive, plusieurs étapes s’enchaînent : réception des documents, déclaration en douane, contrôles éventuels, paiement des droits et taxes, puis enlèvement.',
          'Nous préparons la déclaration, vérifions que les documents sont cohérents entre eux (facture, liste de colisage, connaissement) et suivons le dossier jusqu’à la sortie de la marchandise. Vous savez à chaque étape où en est votre opération.',
        ],
      },
      {
        titre: 'Fret aérien à l’aéroport Mohammed V',
        texte: [
          'Pour les envois urgents, les pièces de rechange ou les marchandises de valeur, le fret aérien passe le plus souvent par l’aéroport Mohammed V. Les formalités sont les mêmes qu’au port, avec des délais de transport plus courts.',
          'Nous coordonnons la réception de la lettre de transport aérien, la déclaration et l’enlèvement, et nous organisons la livraison jusqu’à votre site si besoin.',
        ],
      },
      {
        titre: 'Pour qui travaillons-nous à Casablanca ?',
        texte: ['Importateurs, distributeurs, industriels, commerçants et particuliers qui importent ou exportent ponctuellement : chaque dossier est traité par un interlocuteur qui connaît votre opération.'],
        liste: ['Import de marchandises en conteneur complet ou en groupage', 'Export de produits marocains', 'Matériel et machines pour l’industrie', 'Envois urgents par avion'],
      },
      {
        titre: 'Un interlocuteur sur place',
        texte: ['Être à Casablanca nous permet de suivre vos dossiers au plus près des bureaux de douane et des intervenants du port et de l’aéroport. Vous pouvez nous écrire sur WhatsApp ou demander un devis en ligne : nous étudions votre opération avant de vous répondre.'],
      },
    ],
    faq: [
      { q: 'Où se trouve COGETRANS ?', r: 'Notre société est basée à Casablanca depuis 2003. Nous suivons les dossiers au port de Casablanca, à l’aéroport Mohammed V et dans les autres villes du Maroc.' },
      { q: 'Pouvez-vous dédouaner une marchandise déjà arrivée au port ?', r: 'Oui. Envoyez-nous les documents dont vous disposez (facture, liste de colisage, document de transport) : nous vérifions le dossier et vous disons ce qui manque.' },
      { q: 'Travaillez-vous aussi pour les particuliers ?', r: 'Oui, pour une importation ponctuelle. Décrivez-nous la marchandise et son mode de transport, nous vous expliquons les étapes.' },
    ],
  },
  {
    slug: 'transitaire-tanger',
    nom: 'Tanger',
    titre: 'Transitaire à Tanger et Tanger Med : dédouanement',
    description: 'Dédouanement à Tanger Med, transit et transport routier vers l’Europe : COGETRANS prépare et suit vos dossiers import-export à Tanger. Devis sur demande.',
    h1: 'Transitaire à Tanger et Tanger Med',
    chapo: 'Tanger Med est la grande porte du Maroc sur le détroit de Gibraltar, pour les conteneurs comme pour les camions vers l’Europe. Nous préparons et suivons vos dossiers de dédouanement à Tanger, que vous soyez dans le Nord ou ailleurs au Maroc.',
    portes: ['Port Tanger Med (conteneurs et camions)', 'Port de Tanger Ville', 'Aéroport Tanger Ibn Battouta', 'Zones d’activité de Tanger Med'],
    blocs: [
      {
        titre: 'Le dédouanement à Tanger Med',
        texte: [
          'Beaucoup de marchandises arrivent au Maroc par Tanger Med, même quand elles sont destinées à Casablanca, Fès ou Rabat. Le choix du port dépend de la ligne maritime, de la destination finale et du calendrier.',
          'Nous préparons la déclaration, suivons les éventuels contrôles et organisons l’acheminement de la marchandise vers sa destination une fois dédouanée.',
        ],
      },
      {
        titre: 'Camions vers l’Europe et depuis l’Europe',
        texte: [
          'Tanger est le point de passage naturel du transport routier international entre le Maroc et l’Europe : la remorque traverse le détroit par bateau, puis continue sa route.',
          'Pour vos exportations par camion, nous préparons les formalités de sortie. Pour vos importations, nous suivons l’arrivée de la remorque et son dédouanement.',
        ],
        liste: ['Export de produits finis vers l’Europe', 'Import de pièces et de matières premières', 'Groupage routier pour les petits volumes'],
      },
      {
        titre: 'Les entreprises des zones d’activité',
        texte: ['Les entreprises installées dans les zones d’activité de la région (automobile, textile, logistique) ont des flux réguliers. Un suivi rigoureux des documents évite les retards à chaque passage. Nous travaillons avec vous sur des opérations ponctuelles comme sur des flux réguliers.'],
      },
    ],
    faq: [
      { q: 'Faut-il un transitaire installé à Tanger pour dédouaner à Tanger Med ?', r: 'La déclaration se fait en ligne et le suivi peut se faire à distance. Ce qui compte, c’est un dossier complet et un suivi attentif à chaque étape. Contactez-nous pour en parler.' },
      { q: 'Ma marchandise arrive à Tanger Med mais elle va à Casablanca : comment faire ?', r: 'Nous suivons le dédouanement et organisons le transport jusqu’à Casablanca, ou ailleurs au Maroc.' },
      { q: 'Gérez-vous l’export par camion vers l’Europe ?', r: 'Oui, nous préparons les formalités d’export et coordonnons le transport routier selon votre besoin.' },
    ],
  },
  {
    slug: 'transitaire-agadir',
    nom: 'Agadir',
    titre: 'Transitaire à Agadir : export de produits frais, import',
    description: 'Transitaire pour Agadir et le Souss-Massa : export d’agrumes, de primeurs et de produits de la mer, import par le port d’Agadir. Devis sur demande.',
    h1: 'Transitaire pour Agadir et le Souss-Massa',
    chapo: 'La région d’Agadir exporte des fruits, des légumes et des produits de la mer vers de nombreux pays. Ces marchandises demandent des documents précis et un suivi serré. Nous accompagnons vos exportations comme vos importations depuis Agadir.',
    portes: ['Port d’Agadir', 'Aéroport Agadir Al Massira', 'Route vers Tanger Med pour l’Europe'],
    blocs: [
      {
        titre: 'Exporter des produits frais',
        texte: [
          'Un produit frais ne peut pas attendre. Pour exporter des agrumes, des primeurs ou des produits de la mer, les certificats sanitaires et phytosanitaires, le certificat d’origine et les documents de transport doivent être prêts avant le départ.',
          'Nous vérifions la liste des documents avec vous à l’avance, préparons les formalités d’export et suivons le départ de la marchandise, par la mer ou par la route.',
        ],
        liste: ['Agrumes et primeurs', 'Produits de la mer', 'Huile d’argan et produits du terroir'],
      },
      {
        titre: 'Importer par le port d’Agadir',
        texte: ['Le port d’Agadir reçoit aussi des marchandises pour la région : intrants agricoles, emballages, matériel. Nous préparons la déclaration et suivons le dossier jusqu’à l’enlèvement.'],
      },
      {
        titre: 'Les contrôles à prévoir',
        texte: ['Les produits alimentaires et agricoles passent par des contrôles sanitaires (ONSSA au Maroc, autorités du pays de destination à l’arrivée). Nous vous aidons à savoir quels documents votre marchandise demande, pour éviter un blocage au départ ou à l’arrivée.'],
      },
    ],
    faq: [
      { q: 'Quels documents faut-il pour exporter des fruits depuis Agadir ?', r: 'En général : facture, liste de colisage, certificat phytosanitaire, certificat d’origine et document de transport. La liste exacte dépend du produit et du pays de destination : nous la vérifions avec vous.' },
      { q: 'Peut-on exporter par la route vers l’Europe depuis Agadir ?', r: 'Oui, en camion jusqu’à Tanger Med puis par bateau. Nous préparons les formalités et coordonnons le transport.' },
      { q: 'Travaillez-vous avec les coopératives ?', r: 'Oui. Coopératives, exportateurs et petites entreprises : chaque dossier a son interlocuteur.' },
    ],
  },
  {
    slug: 'transitaire-marrakech',
    nom: 'Marrakech',
    titre: 'Transitaire à Marrakech : import, export et dédouanement',
    description: 'Transitaire pour Marrakech : import d’équipement pour l’hôtellerie, export d’artisanat, fret aérien par l’aéroport Menara. COGETRANS suit vos dossiers.',
    h1: 'Transitaire pour Marrakech',
    chapo: 'Marrakech n’a pas de port : ses marchandises arrivent le plus souvent par Casablanca, Agadir ou Tanger Med, puis par la route, ou par avion à l’aéroport Menara. Nous organisons le dédouanement et l’acheminement jusqu’à Marrakech.',
    portes: ['Aéroport Marrakech Menara', 'Ports de Casablanca, d’Agadir ou de Tanger Med, puis la route'],
    blocs: [
      {
        titre: 'Équiper un hôtel, un riad, un restaurant',
        texte: [
          'Mobilier, cuisine professionnelle, linge, décoration : les projets d’hôtellerie importent souvent beaucoup de marchandises différentes, de plusieurs fournisseurs. Chaque envoi a ses documents.',
          'Nous centralisons le suivi : vous savez ce qui est arrivé, ce qui est en douane et ce qui part vers Marrakech.',
        ],
      },
      {
        titre: 'Exporter l’artisanat',
        texte: ['Tapis, poterie, cuir, luminaires : pour vendre à l’étranger, un artisan ou une boutique a besoin d’une facture claire, d’une liste de colisage et parfois d’un certificat d’origine. Nous préparons l’export par avion ou par la route, selon le volume et le délai.'],
        liste: ['Envois par avion depuis Menara', 'Groupage routier vers l’Europe', 'Conseil sur les documents à fournir'],
      },
      {
        titre: 'Événements et matériel temporaire',
        texte: ['Pour un salon, un tournage ou un événement, du matériel peut entrer au Maroc pour une durée limitée puis repartir. Ce cas suit des règles particulières en douane (admission temporaire) : parlons-en avant l’arrivée du matériel.'],
      },
    ],
    faq: [
      { q: 'Ma marchandise pour Marrakech arrive à Casablanca : qui s’occupe du transport ?', r: 'Nous pouvons suivre le dédouanement à Casablanca puis organiser le transport routier jusqu’à Marrakech.' },
      { q: 'Je suis artisan, puis-je exporter de petites quantités ?', r: 'Oui. Le groupage permet d’envoyer de petits volumes. Décrivez-nous votre envoi pour que nous étudiions la meilleure solution.' },
      { q: 'Faites-vous le dédouanement à l’aéroport Menara ?', r: 'Contactez-nous avec le détail de l’envoi : nous vous disons comment nous le prenons en charge.' },
    ],
  },
  {
    slug: 'transitaire-rabat',
    nom: 'Rabat',
    titre: 'Transitaire à Rabat et Salé : dédouanement import-export',
    description: 'Transitaire pour Rabat, Salé et Témara : import d’équipement, marchés publics, envois par avion ou par le port de Casablanca. COGETRANS suit vos dossiers.',
    h1: 'Transitaire pour Rabat, Salé et Témara',
    chapo: 'Les entreprises et les institutions de Rabat importent du matériel informatique, des équipements techniques et des fournitures. Leurs marchandises arrivent souvent par le port de Casablanca ou par avion. Nous suivons le dossier jusqu’à la livraison à Rabat.',
    portes: ['Aéroport Rabat-Salé', 'Port de Casablanca, puis la route', 'Aéroport Mohammed V'],
    blocs: [
      {
        titre: 'Matériel et équipements',
        texte: [
          'Informatique, télécommunications, matériel médical ou scientifique : certains produits demandent, en plus de la déclaration, une autorisation ou un contrôle de conformité avant d’entrer au Maroc.',
          'Nous vérifions ce point avec vous avant l’expédition. C’est le meilleur moyen d’éviter qu’une marchandise reste bloquée.',
        ],
      },
      {
        titre: 'Marchés publics et projets',
        texte: ['Pour un fournisseur d’un marché public, le calendrier de livraison compte. Nous préparons le dossier de dédouanement à l’avance et suivons chaque étape pour respecter vos délais de livraison autant que possible.'],
        liste: ['Préparation des documents avant l’arrivée', 'Suivi du dédouanement', 'Livraison jusqu’au site à Rabat'],
      },
      {
        titre: 'Proches de vous',
        texte: ['Rabat est à une heure de route de Casablanca, où nous sommes installés. Nous suivons vos dossiers à distance et vous tenons informés par téléphone, e-mail ou WhatsApp.'],
      },
    ],
    faq: [
      { q: 'Faut-il une autorisation pour importer du matériel de télécommunication ?', r: 'Certains équipements demandent une homologation ou un contrôle avant l’entrée au Maroc. Donnez-nous la référence du produit : nous vérifions avec vous avant l’expédition.' },
      { q: 'Livrez-vous à Rabat après le dédouanement ?', r: 'Oui, nous organisons le transport jusqu’à votre site.' },
      { q: 'Pouvez-vous suivre un envoi par avion ?', r: 'Oui, depuis l’aéroport Mohammed V ou selon l’arrivée de votre envoi.' },
    ],
  },
  {
    slug: 'transitaire-fes',
    nom: 'Fès',
    titre: 'Transitaire à Fès : import de matières, export artisanat',
    description: 'Transitaire pour Fès et Meknès : import de matières premières et de machines, export de cuir, de textile et d’artisanat. COGETRANS suit vos dossiers.',
    h1: 'Transitaire pour Fès et Meknès',
    chapo: 'Fès travaille le cuir, le textile, l’artisanat et l’agroalimentaire. Les matières premières arrivent par Tanger Med ou Casablanca, les produits finis repartent vers l’Europe et ailleurs. Nous suivons ces opérations dans les deux sens.',
    portes: ['Aéroport Fès-Saïss', 'Port Tanger Med, puis la route', 'Port de Casablanca, puis la route'],
    blocs: [
      {
        titre: 'Importer des matières premières et des machines',
        texte: [
          'Peaux, fils, tissus, produits chimiques, machines de production : chaque catégorie a ses règles. Une machine d’occasion, par exemple, ne se déclare pas comme une machine neuve.',
          'Nous étudions la marchandise avec vous, préparons la déclaration et suivons le dossier jusqu’à la livraison à Fès.',
        ],
      },
      {
        titre: 'Exporter cuir, textile et artisanat',
        texte: ['Pour vendre à l’étranger, il faut une facture précise, une liste de colisage et souvent un certificat d’origine, qui peut permettre à votre client de payer moins de droits à l’arrivée selon les accords entre pays. Nous préparons ces documents avec vous.'],
        liste: ['Maroquinerie et cuir', 'Textile et confection', 'Céramique, zellige et artisanat'],
      },
      {
        titre: 'Par Tanger Med ou par Casablanca ?',
        texte: ['Fès est à distance comparable de Tanger Med et de Casablanca. Le bon choix dépend de la ligne maritime, du pays d’origine ou de destination et du calendrier. Nous vous conseillons au cas par cas.'],
      },
    ],
    faq: [
      { q: 'Le certificat d’origine est-il obligatoire pour exporter ?', r: 'Pas toujours, mais il peut permettre à votre client de bénéficier de droits réduits dans son pays. Nous vous disons s’il est utile pour votre envoi.' },
      { q: 'Pouvez-vous importer une machine d’occasion ?', r: 'Oui, mais elle suit des règles particulières. Envoyez-nous la description et l’année de la machine pour que nous étudiions le dossier.' },
      { q: 'Travaillez-vous aussi avec Meknès ?', r: 'Oui, nous suivons les dossiers des entreprises de Meknès et de toute la région.' },
    ],
  },
  {
    slug: 'transitaire-nador',
    nom: 'Nador',
    titre: 'Transitaire à Nador : dédouanement au port de Beni Ensar',
    description: 'Transitaire pour Nador et l’Oriental : dédouanement au port de Nador, import de marchandises et transport vers l’intérieur du Maroc. Devis sur demande.',
    h1: 'Transitaire pour Nador et l’Oriental',
    chapo: 'Le port de Nador (Beni Ensar) relie l’Oriental à l’Europe et à la Méditerranée. Nous suivons le dédouanement de vos marchandises à Nador et leur acheminement vers Oujda, Fès ou le reste du Maroc.',
    portes: ['Port de Nador (Beni Ensar)', 'Aéroport Nador Al Aroui', 'Route vers Oujda et l’intérieur du pays'],
    blocs: [
      {
        titre: 'Dédouaner au port de Nador',
        texte: [
          'Le port de Nador accueille des marchandises et des remorques en provenance d’Europe. Comme ailleurs, tout part d’un dossier complet : facture, liste de colisage, document de transport et, selon la marchandise, autorisations ou certificats.',
          'Nous préparons la déclaration et suivons chaque étape jusqu’à l’enlèvement.',
        ],
      },
      {
        titre: 'Commerce et distribution dans l’Oriental',
        texte: ['Matériaux de construction, produits alimentaires, équipements : les commerçants et distributeurs de Nador, d’Oujda et de Berkane importent régulièrement. Un suivi rigoureux évite qu’une erreur de document bloque toute une livraison.'],
        liste: ['Import en conteneur ou en remorque', 'Transport jusqu’à votre dépôt', 'Conseil sur la classification de la marchandise'],
      },
    ],
    faq: [
      { q: 'Pouvez-vous suivre un dossier à Nador depuis Casablanca ?', r: 'Oui. La déclaration se fait en ligne et nous suivons le dossier avec les intervenants du port.' },
      { q: 'Livrez-vous à Oujda ?', r: 'Oui, nous organisons le transport vers Oujda et le reste de l’Oriental.' },
    ],
  },
  {
    slug: 'transitaire-kenitra',
    nom: 'Kénitra',
    titre: 'Transitaire à Kénitra : industrie, zone franche, agro',
    description: 'Transitaire pour Kénitra et le Gharb : flux industriels de la zone d’accélération industrielle, export agricole, dédouanement et transport. Devis sur demande.',
    h1: 'Transitaire pour Kénitra et le Gharb',
    chapo: 'Kénitra s’est imposée comme une ville industrielle, avec sa zone d’accélération industrielle (Atlantic Free Zone) et ses usines tournées vers l’export. La plaine du Gharb exporte aussi des fruits et légumes. Nous suivons ces flux.',
    portes: ['Port de Casablanca ou Tanger Med, puis l’autoroute', 'Aéroport Mohammed V ou Rabat-Salé'],
    blocs: [
      {
        titre: 'Les entreprises de la zone industrielle',
        texte: [
          'Une entreprise installée en zone d’accélération industrielle suit un régime douanier particulier pour ses entrées et ses sorties de marchandises. Les documents doivent être exacts à chaque mouvement.',
          'Nous travaillons avec les équipes logistiques pour préparer les formalités et suivre les flux, réguliers ou ponctuels.',
        ],
      },
      {
        titre: 'Export agricole du Gharb',
        texte: ['Fruits rouges, agrumes, légumes : comme pour tout produit frais, les certificats sanitaires et l’organisation du départ doivent être prêts à temps. Nous préparons les formalités d’export et coordonnons le transport vers le port ou la frontière.'],
        liste: ['Formalités d’export', 'Coordination avec le transporteur', 'Suivi du départ'],
      },
    ],
    faq: [
      { q: 'Accompagnez-vous les entreprises de l’Atlantic Free Zone ?', r: 'Oui. Présentez-nous vos flux et vos besoins : nous étudions avec vous la meilleure organisation.' },
      { q: 'Par quel port passent les marchandises de Kénitra ?', r: 'Le plus souvent par Casablanca ou Tanger Med, selon la ligne maritime et la destination. Nous vous conseillons au cas par cas.' },
    ],
  },
]
